//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ABIC',
  data() {
    return {
      defaultJson: {
        "Age": "年龄",
        "INR": "INR",
        "Total bilirubin": "总胆红素",
        "Serum creatinine": "血肌酐",
      },
      form: {
        age: '',
        inr: '',
        bilirubin: '',
        creatinine: '',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log('gggggggg', form);
        // 年龄*0.1+胆红素*0.08+肌酐*0.3+INR*0.8
        let result = form.age * 0.1 + form.bilirubin * 0.08 + form.creatinine * 0.3 + form.inr * 0.8
        console.log(78, result)
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/ABIC.vue